import {
  classesListFilter,
  classesListFilterSelection,
  customerTypeFilter,
  customerTypeFilterSelection,
  defaultOrgTypesDataReceiver,
  orgTypesFilter,
  orgTypesFilterSelection,
  orgsFilter,
  orgsFilterSelection,
  periodFilter,
  schoolYearFilter,
  schoolYearFilterSelection,
  studentListFilter,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'


export const filterInit = () => {
  orgTypesFilter.addDataReceiver(
    defaultOrgTypesDataReceiver,
  )
  orgTypesFilter.dataReceive()
  orgTypesFilter.setStatusReady()


  return () => {
    orgTypesFilterSelection.reset()
    orgsFilterSelection.reset()
    customerTypeFilterSelection.reset()
    schoolYearFilterSelection.reset()
    classesListFilterSelection.reset()
    studentListFilterSelection.reset()

    orgTypesFilter.reset()
    orgsFilter.reset()
    periodFilter.reset()
    customerTypeFilter.reset()
    schoolYearFilter.reset()
    classesListFilter.reset()
    studentListFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  orgTypesFilterSelection.resetToDefault()
  orgsFilterSelection.resetToDefault()
  periodFilter.resetToDefault()
  customerTypeFilterSelection.resetToDefault()
  schoolYearFilterSelection.resetToDefault()
  classesListFilterSelection.resetToDefault()
  studentListFilterSelection.resetToDefault()
}
